import Vue from 'vue'
import firebase from 'firebase'
import { firestorePlugin } from 'vuefire'

Vue.use(firestorePlugin)  

const firebaseConfig = {
  apiKey: "AIzaSyCq0du9GNCfrz7fC4KG4vw2moUisRoM960",
  authDomain: "terminal-rpg.firebaseapp.com",
  databaseURL: "https://terminal-rpg.firebaseio.com",
  projectId: "terminal-rpg",
  storageBucket: "terminal-rpg.appspot.com",
  messagingSenderId: "799701636365",
  appId: "1:799701636365:web:df188035f196409f348c44",
  measurementId: "G-X7PWEGDKYL"
};
export const firebaseInit = firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore()